// src/store/api/auth.js
import api, { getCSRFToken } from './base';

// Signup - Register a new user
export const signup = async (userData) => {
  // Ensure we have a fresh CSRF token before signup
  await getCSRFToken();
  const response = await api.post('/auth/signup', userData);
  return response.data;
};

// Verify Signup OTP
export const verifySignupOTP = async (verificationData) => {
  const response = await api.post('/auth/verify-signup', verificationData);
  return response.data;
};

// Login - Send OTP to registered phone
export const login = async (loginData) => {
  // Ensure we have a fresh CSRF token before login
  await getCSRFToken();
  const response = await api.post('/auth/login', loginData);
  return response.data;
};

// Verify Login OTP
export const verifyLoginOTP = async (verificationData) => {
  const response = await api.post('/auth/verify-login', verificationData);
  return response.data;
};

// Resend OTP for login or signup
export const resendOTP = async (resendData) => {
  // Ensure we have a fresh CSRF token
  await getCSRFToken();
  const response = await api.post('/auth/resend-otp', resendData);
  return response.data;
};

// Logout user
export const logout = async () => {
  try {
    // Get fresh CSRF token
    await getCSRFToken();
    
    // Get token from session storage
    const token = sessionStorage.getItem('token');
    
    // Only make the API call if there's a token
    if (token) {
      const response = await api.post('/auth/logout', {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    }
    
    // If no token, return a successful response
    return {
      status: 'success',
      message: 'Logged out successfully'
    };
  } catch (error) {
    // console.error('Logout API error:', error);
    
    // Even if the API call fails, we want the client-side logout to succeed
    // So we'll return a success response and log the error
    return {
      status: 'success',
      message: 'Logged out from device',
      error: error.message
    };
  }
};

// Check if user session is valid
export const checkAuth = async () => {
  try {
    const token = sessionStorage.getItem('token');
    if (!token) {
      throw new Error('No token found');
    }
    
    // We'll use the health endpoint as a simple check
    const response = await api.get('/health');
    return response.status === 200;
  } catch (error) {
    // console.error('Auth check failed:', error);
    return false;
  }
};